import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBranches } from "../../services/get.service";
import { postStaff } from "../../services/post.service";
import { toast } from "react-toastify";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { branch } from "../type";
import { staff, staffAddress } from "../../validations/Validation"

export interface IUseCreateStaff {
  onSubmit: (data: any) => void;
  registerGeneral: any;
  registerAddress: any;
  unRegisterAddress: any;
  handleSubmitGeneral: any;
  handleSubmitAddress: any;
  errorsGeneral: any;
  errorsAddress: any;
  branch: any;
  formValue: any;
  setFormValue: any;
  addressFields: any;
  appendAddress: any;
  addressRemove: any;
  loading: boolean;
}

export const useCreateStaff = (): IUseCreateStaff => {
  const [formValue, setFormValue] = useState<any>({});
  const [branch, setBranch] = useState<Array<branch>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const naviagte = useNavigate();

  useEffect(() => {
    getBranches().then((res) => setBranch(res.data));
  }, []);

  const onSubmit = () => {
    setLoading(true);
    var id = toast.loading("Please wait...", {
      theme: "colored",
      type: "info",
      closeButton: true,
    });

    postStaff(formValue)
      .then((res) => {
        toast.update(id, {
          render: res.data,
          type: "success",
          theme: "colored",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setLoading(false);
        naviagte("/staffs");
      })
      .catch((err) => {
        toast.update(id, {
          render: err?.response?.data?.detail,
          theme: "colored",
          autoClose: 5000,
          type: "error",
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setLoading(false);
        console.log(err);
      });
  };

  const {
    register: registerGeneral,
    handleSubmit: handleSubmitGeneral,
    control,
    formState: { errors: errorsGeneral },
  } = useForm({
    resolver: yupResolver(staff),
    defaultValues: { addresses: formValue.addresses },
  });

  const {
    register: registerAddress,
    handleSubmit: handleSubmitAddress,
    unregister: unRegisterAddress,
    formState: { errors: errorsAddress },
  } = useForm({
    resolver: yupResolver(staffAddress),
  });

  const {
    fields: addressFields,
    append: addressAppend,
    remove: addressRemove,
  } = useFieldArray({
    control,
    name: "addresses",
  });

  const appendAddress = () => {
    addressAppend({});
  };

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    branch,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  };
};
